import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-311f4a54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "good-road-panel-root" }
const _hoisted_2 = { class: "tab-menu-group" }
const _hoisted_3 = { class: "tabs" }
const _hoisted_4 = { class: "tab-label" }
const _hoisted_5 = { class: "tab-count" }
const _hoisted_6 = { class: "tab-label" }
const _hoisted_7 = { class: "tab-count" }
const _hoisted_8 = { class: "tab-label" }
const _hoisted_9 = { class: "tab-count" }
const _hoisted_10 = { class: "good-road-list-wrap" }
const _hoisted_11 = { class: "good-road-list" }
const _hoisted_12 = { class: "chips-control-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_x = _resolveComponent("icon-x")!
  const _component_good_road_item = _resolveComponent("good-road-item")!
  const _component_ctrl_chips = _resolveComponent("ctrl-chips")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["tab-item", { active: _ctx.tabId === 'ALL' }]),
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.switchTab('ALL')), ["prevent"]))
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.t('loby.all')), 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.tabGoodRoadCounts.ALL), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["tab-item", { active: _ctx.tabId === 'G002' }]),
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.switchTab('G002')), ["prevent"]))
        }, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('common.baccarat')), 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.tabGoodRoadCounts.G002), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["tab-item", { active: _ctx.tabId === 'G003' }]),
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.switchTab('G003')), ["prevent"]))
        }, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.t('common.dragontiger')), 1),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.tabGoodRoadCounts.G003), 1)
        ], 2)
      ]),
      _createVNode(_component_icon_x, {
        class: "close",
        close: "",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
      })
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_TransitionGroup, {
          name: "good-road-list-item-transition",
          tag: "div",
          class: "good-road-list"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listData, (entry) => {
              return (_openBlock(), _createBlock(_component_good_road_item, {
                key: entry.table.id,
                "m-data": entry,
                "is-free-baccarat": _ctx.isFreeBaccarat,
                class: "good-road-list-item"
              }, null, 8, ["m-data", "is-free-baccarat"]))
            }), 128))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_ctrl_chips, { class: "chips-group" })
    ])
  ]))
}